import {IdName,ColumnIds, PageName,PlacementRecord, PivotGroupByOption, PivotIds} from "./types";
import dayjs from "./dayjs";

const BASE_GROUP_BY_ARRAY : IdName[]= [
  { id : ColumnIds.date, name : "Date" },
  { id : ColumnIds.week, name : "Week" },
  { id : ColumnIds.month, name : "Month" },
  { id : ColumnIds.apptapPublisherID, name : "AppTap Publisher ID"},
  { id : ColumnIds.apptapSiteID, name : "AppTap Site ID"},
  { id : ColumnIds.publisherPlacementID, name : "Publisher Placement ID"},
];

const OVERALL_GROUP_BY_ARRAY : IdName[]= [
  ...BASE_GROUP_BY_ARRAY,
  { id : ColumnIds.country, name : "Country"},
  { id : ColumnIds.trafficType, name : "Traffic Type"},
  { id : ColumnIds.algorithmSplit, name : "Algorithm Split"},
  { id : ColumnIds.designSplit, name : "Design Split"},
  // support_tags/notes
  // { id : ColumnIds.tags, name : "Tags"}
];

const PRODUCTS_GROUP_BY_ARRAY : IdName[]= [ 
  ...OVERALL_GROUP_BY_ARRAY, 
  { id : ColumnIds.productID, name : "Product ID" },
  { id : ColumnIds.campaignSource, name : "Campaign Source"},
  { id : ColumnIds.campaignSourceAlias, name : "Campaign Source Alias"},
  { id : ColumnIds.campaignID, name : "AppTap Campaign ID"},
  { id : ColumnIds.demandPlacementID, name : "Demand Placement ID"},
  { id : ColumnIds.bidStatus, name : "Bid Status"},
  { id : ColumnIds.cLinkId, name : "cLink ID"},
  { id : ColumnIds.cLinkOwner, name : "cLink Owner"},
  // support_tags/notes
  // { id : ColumnIds.cLinkTags, name : "cLink Tags"},
  { id : ColumnIds.apptapOfferId, name : "AppTap Offer ID"},
  { id : ColumnIds.untrackedReason, name : "Untracked Reason"},
  { id : ColumnIds.creativeId, name : "Creative ID"},
  { id : ColumnIds.campaignEventType, name : "Campaign Event Type"},
  { id : ColumnIds.campaignEventId, name : "Campaign Event ID"}
];

const PERFORMANCE_REPORTS_GROUP_BY_ARRAY : IdName[]= [ 
  ...BASE_GROUP_BY_ARRAY, 
  { id : ColumnIds.productID, name : "Product ID" },
  { id : ColumnIds.campaignSource, name : "Campaign Source", required: true },
  { id : ColumnIds.campaignSourceAlias, name : "Campaign Source Alias", required: true },
  { id : ColumnIds.campaignID, name : "AppTap Campaign ID"},
  { id : ColumnIds.demandAccountID, name : "Demand Account ID" },
  { id : ColumnIds.demandPlacementID, name : "Demand Placement ID"},
  { id : ColumnIds.apptapPlacementID, name : "AppTap Placement ID"},
  { id : ColumnIds.productItemID, name : "Product Item ID"},
  { id : ColumnIds.productItemName, name : "Product Item Name"}
];
// postConversionEvents="postConversionEvents",
// demandAccountId="demandAccountId",
// demandPlacementId="demandPlacementId",
// postConversionEventRate="postConversionEventRate"


export function getGroupByItemsPerPage(page : string) : IdName[] {
  let gbItems : IdName[] = [];
  switch( page ){
    case  PageName.overall:
      gbItems = OVERALL_GROUP_BY_ARRAY;
      break;

    case  PageName.products:
      gbItems = PRODUCTS_GROUP_BY_ARRAY;
      break;

    case  PageName.performanceReports:
      gbItems = PERFORMANCE_REPORTS_GROUP_BY_ARRAY;
      break;
  }
  return gbItems;  
}

export function getGroupByArray(page : string, allowedGroupByFields : string[], currentGroupByState : any[] =  []) : IdName[]{
  if( allowedGroupByFields === undefined || allowedGroupByFields === null || allowedGroupByFields.length === 0){
    return [];
  }
  let fullGroupbyArray : IdName[] = [];

  switch( page ){
    case  PageName.overall:
      fullGroupbyArray = OVERALL_GROUP_BY_ARRAY;
      break;

    case  PageName.products:
      fullGroupbyArray = PRODUCTS_GROUP_BY_ARRAY;
      break;

    case  PageName.performanceReports:
      fullGroupbyArray = PERFORMANCE_REPORTS_GROUP_BY_ARRAY;
      break;
  }


  let returnedArray = fullGroupbyArray.filter((item) => allowedGroupByFields.includes(item.id));
  return returnedArray;
}


export const TRAFFIC_TYPES_ARRAY : IdName[] = [
  { id : "all-mobile", name : "All-Mobile"},
  { id : "mobile-android", name : "- Mobile-Android"},
  { id : "mobile-ios", name : "- Mobile-IOS"},
  { id : "mobile-other", name : "- Mobile-Other"},
  { id : "all-desktop", name : "All-Desktop"},
  { id : "desktop-other", name : "- Desktop-Other"},
  { id : "desktop-NoUserAgent", name : "- Desktop-NoUserAgent"}
];

export function checkForMatch(needles:string[], stack:string): boolean {
    if ( needles == null || needles.length === 0 ) {
      return true;
    }
    return !!needles.every( needle => stack.indexOf(needle) >= 0 );
}

export function buildStaticOptions(query: string): PlacementRecord[] {
  const staticOptions: PlacementRecord[] = []
  
  const searchExact: PlacementRecord = {} as PlacementRecord
  searchExact.apptapPublisherId = null;
  searchExact.apptapSiteId = null;
  searchExact.publisherPlacementId = query;
  searchExact.publisherPlacementName = "All traffic sources, find where publisher placement is exactly [" + query + "]";
  staticOptions.push(searchExact);

  const searchSubstring: PlacementRecord = {} as PlacementRecord
  searchSubstring.apptapPublisherId = null;
  searchSubstring.apptapSiteId = null;
  searchSubstring.publisherPlacementId = "***" + query + "***";
  searchSubstring.publisherPlacementName = "All traffic sources, find where publisher placement contains […" + query + "…]";
  staticOptions.push(searchSubstring);

  const searchPrefix: PlacementRecord = {} as PlacementRecord
  searchPrefix.apptapPublisherId = null;
  searchPrefix.apptapSiteId = null;
  searchPrefix.publisherPlacementId = query + "***"
  searchPrefix.publisherPlacementName = "All traffic sources, find where publisher placement starts with [" + query + "…]";
  staticOptions.push(searchPrefix);

  const searchSuffix: PlacementRecord = {} as PlacementRecord
  searchSuffix.apptapPublisherId = null;
  searchSuffix.apptapSiteId = null;
  searchSuffix.publisherPlacementId = "***" + query;
  searchSuffix.publisherPlacementName = "All traffic sources, find where publisher placement ends with […" + query + "]";
  staticOptions.push(searchSuffix);

  return staticOptions;
}


export const pivotGroupByOptions:PivotGroupByOption[] = [
  {
    id: PivotIds.off,
    name: "Remove Pivot",
    dateStart: null,
    dateEnd: null,
    dateMode: null,
  },
  {
    id: PivotIds.current,
    name: "Current dates",
    dateStart: null,
    dateEnd: null,
    dateMode: null,
  },
  {
    id: PivotIds.last7days,
    name: "Last 7 days",
    dateStart: dayjs.utc().subtract(6, "days").startOf("day"),
    dateEnd: dayjs.utc().startOf("day"),
    dateMode: "days",
  },
  {
    id: PivotIds.last14days,
    name: "Last 14 days",
    dateStart: dayjs.utc().subtract(13, "days").startOf("day"),
    dateEnd: dayjs.utc().startOf("day"),
    dateMode: "days",
  },
  {
    id: PivotIds.last90days,
    name: "Last 90 days",
    dateStart: dayjs.utc().subtract(92, "days").startOf("day"),
    dateEnd: dayjs.utc().startOf("day"),
    dateMode: "days",
  },
  {
    id: PivotIds.last12weeks,
    name: "Last 12 weeks",
    dateStart: dayjs.utc().subtract(12, "weeks").startOf("isoWeek").startOf('day'),
    dateEnd: dayjs.utc().endOf("isoWeek").startOf('day'),
    dateMode: "weeks",
  },
  {
    id: PivotIds.last12months,
    name: "Last 12 months",
    dateStart: dayjs.utc().startOf("day").subtract(1, "years").startOf('month').startOf('day'),
    dateEnd: dayjs.utc().endOf("month").startOf('day'),
    dateMode: "months",
  },
  {
    id: PivotIds.last2years,
    name: "Last 24 months",
    dateStart: dayjs.utc().startOf('month').startOf("day").subtract(2, "years").startOf('day'),
    dateEnd: dayjs.utc().endOf("month").startOf('day'),
    dateMode: "months",
  }
];

export function camelCaseToTitleCase(str:string):string {
  return str.replace(/([A-Z])/g, (match) => ` ${match}`).replace(/^./, (match) => match.toUpperCase()).trim();
};

export function camelCaseToKebabCase(str:string):string {
  return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())
};

export function checkChildElementsContainsTagAndClasses(children:HTMLCollection, tagName:string, cssClasses:string[]):boolean {
  if (!children || children.length === 0) return false;

  for (const element of Array.from(children)) {
    if (element instanceof HTMLElement && element.tagName === tagName) {
      return cssClasses.every((cssClass) => element.classList.contains(cssClass));
    }
  }
  return false;
}

export function isGreaterOSVersion(baseVersion:string, newVersion:string):boolean {
  try {
    let b = baseVersion.replace( /[+\-=]/, "" ).split( "." );
    let n = newVersion.replace( /[+\-=]/, "" ).split( "." );
    
    let baseMajor = parseInt( b[0] );
    let baseMinor = b[1] ? parseInt( b[1] ) : 0;
    let baseRevision = b[2] ? parseInt( b[2] ) : 0;
    
    let newMajor = parseInt( n[0] );
    let newMinor = n[1] ? parseInt( n[1] ) : 0;
    let newRevision = n[2] ? parseInt( n[2] ) : 0;
    
    // Compare major
    if ( newMajor < baseMajor ) {
      return false;
    }
    if ( newMajor > baseMajor ) {
      return true;
    }
    
    // Compare minor
    if ( newMinor < baseMinor ) {
      return false;
    }
    if ( newMinor > baseMinor ) {
      return true;
    }
    
    // Compare revision
    if ( newRevision < baseRevision ) {
      return false;
    }
    if ( newRevision > baseRevision ) {
      return true;
    }
    
    return false;
  }
  catch ( exception ) {
    console.error( "Problem handling OS version: " + exception );
    return false;
  }
};

export function formatSearchInRowToBold(text:string, search:string) {
  const reg = new RegExp(search, 'gi');
  return text.replace(reg, (search) => "<strong>" + search + "</strong>");
};